import { BillingUpdate } from '../components/Settings/Billing/BillingUpdate/BillingUpdate'

export const BillingUpdatePage = () => {
    return <BillingUpdate />
}
